import { useState } from "react";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { NavLink, useNavigate } from "react-router-dom";
import "./Auth.css";
import { db } from "../../index";
import { ref, set } from "firebase/database";

export function Signup() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [copyPassword, setCopyPassword] = useState("");
    const [error, setError] = useState("");
    const auth = getAuth();
    const navigate = useNavigate();

    async function handleSignUp(e) {
        e.preventDefault();
        if (password.length < 6) {
            setError("Пароль должен быть больше 6 символов");
            return;
        }
        if (copyPassword !== password) {
            setError("Пароли не совпадают");
            return;
        }
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            console.log(user);
            setError("");
            setEmail("");
            setPassword("");
            setCopyPassword("");
            set(ref(db, `users/${user.uid}`), {
                userID: user.uid,
                email: user.email,
                displayName: "",
                phoneNumber: "",
                role: "Инженер",
            });
            alert("Регистрация прошла успешно");
            navigate('/signin');
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="center-auth">
            <h2>Maint<span>Mend</span></h2>
            <h1>Создайте аккаунт</h1>
            <form onSubmit={handleSignUp}>
            <div className="txt_field">
                <input
                    id="email"
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e)=>setEmail(e.target.value)}
                    placeholder="Почта"
                    required
                />
                <span></span>
            </div>
            <div className="txt_field">
                <input
                    id="password"
                    type="password"
                    name="password"
                    value={password}
                    onChange={(e)=>setPassword(e.target.value)}
                    minLength="6"
                    placeholder="Пароль"
                    required
                />
                <span></span>
            </div>
            <div className="txt_field">
                <input
                    id="copyPassword"
                    type="password"
                    name="copyPassword"
                    value={copyPassword}
                    onChange={(e)=>setCopyPassword(e.target.value)}
                    placeholder="Повторите пароль"
                    required
                />
                <span></span>
            </div>
            <button className="form-login__input">Создать</button>
            {error ? <p style={{color:"red"}}>{error}</p> : ""}
            <div className="signup_link">Аккаунт уже существует? <NavLink to="/signin">Авторизируйтесь</NavLink></div>
            </form>
        </div>
    )
}
